import React from 'react';
import classnames from 'classnames';

const BringzzShimmer = ({ className, height, width, rounded = false }) => {
  return (
    <div 
      className={classnames(
        'relative overflow-hidden bg-gray-200',
        rounded && 'rounded-lg',
        className
      )}
      style={{ 
        height: height || '100%',
        width: width || '100%'
      }}
    >
      <div 
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)',
          animation: 'shimmer 1.5s infinite',
        }}
      />
      <style jsx>{`
        @keyframes shimmer {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
      `}</style>
    </div>
  );
};

export default BringzzShimmer; 